// removed by extract-text-webpack-plugin
module.exports = {"login-navigation":"login-module_login-navigation_3XSLn","forgot-password":"login-module_forgot-password_Ak0Dv","formControls":"login-module_formControls_3PkZq","facebookButton":"login-module_facebookButton_nGbVQ","googleButton":"login-module_googleButton_2DLTY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/login.module.scss
// module id = 1328
// module chunks = 0